import { IconColor } from 'components/Icon';

const notRosteredColor: IconColor = 'koala';
const notRosteredIcon = 'link-unlinked';
const notRosteredLabel = 'Not SIS linked';
const rosteredColor: IconColor = 'shamrock';
const rosteredIcon = 'link-linked';
const rosteredLabel = 'Linked to SIS';

export default {
  notRosteredColor,
  notRosteredIcon,
  notRosteredLabel,
  rosteredColor,
  rosteredIcon,
  rosteredLabel,
};
